import { initSentry, Sentry } from "./lib/sentry";
import { initPostHog } from "./lib/posthog";
initSentry();
initPostHog();

import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

window.addEventListener("unhandledrejection", (event) => {
  console.error("[Unhandled rejection]", event.reason);
  Sentry.captureException(event.reason);
  event.preventDefault();
});

createRoot(document.getElementById("root")!).render(<App />);
